/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */
import React from "react";
import Button from "../shared-ui/button";
import ProductImg from "../../assets/product-img.png";
import Slider from "react-slick";
import FoodComponent from "../summary/food";
import TipsComponent from "../summary/tips";
import ResultsHeader from "../shared-ui/results-header";
import StarRatings from "react-star-ratings";
import QuantityButton from "../shared-ui/quantity-button";
import DetailsComponent from "../details";
import { getGroupedTipsData } from "../../utils/tipsData";
import _, { filter, isEmpty, result } from "lodash";
import tomatoes from "../../assets/tomatoes.png";
//import { response } from "./mock-response";
import { setAccessToken } from "../../services/commerceServices/accessToken";
import {
  fetchProductDetails,
  fetchProductReview,
} from "../../services/commerceServices/productDetails";
import {
  addCartEntries,
  cartMergingCall,
  deductCartEntriesCount,
  deleteCartEntries,
  getCartEntries,
  getOrCreateCart,
} from "../../services/commerceServices/cartServices";
import {
  createSuggesticUser,
  getAllPrograms,
  getAllRestrictions,
  searchByIngredients,
  setProfileCustomAttribute,
  setProgramIds,
  setUserRestriction,
  suggesticCalls,
} from "../../services/suggesticServices";

import { withOktaAuth } from "@okta/okta-react";
// import { createSuggesticUser } from "../../services/suggesticServices";
import Footer from "../shared-ui/footer";
import CartComponent from "../shared-ui/cart";
import { getGroupedProductsData } from "../../utils/productsData";
import { getContentFromContentStack } from "../../core/contentStack";
import SaveResultsPopup from "../shared-ui/popup/save-results";
import MessageStrip from "../shared-ui/message-strip";
import { formattedText } from "../../utils/formattedText";
import { getNeedStatesInfo } from "../../utils/needStateInformation";
import { validateOktaSession } from "../../utils/validateOktaSession";
import { getGroupedFoodsData } from "../../utils/foodsData";
import { getGroupedReasonsData } from "../../utils/reasonData";
import ReactHtmlParser from "react-html-parser";
import {
  compareExpiryTime,
  compareGuestExpiryTime,
  setGuestSaveResultTime,
  setGuestExpiryTime,
} from "../../utils/handleExpiryTime";
import { clearSession } from "../../utils/clearSession";
import { handleGuestExpiryPopup } from "../../utils/handlePopups";
import { response } from "./mock-response";
import fallbackImageThumbnail from "../../assets/fallBackImageThumbnail.png";
import fallbackImageProduct from "../../assets/fallBackImageProduct.png";
import { asyncLocalStorage } from "../../utils/asyncStorage";
import Loader from "../shared-ui/loader";
import { uniqueUserId } from "../../utils/generateUniqueId";
import { utag, withUtag } from "../analytics/analytics";
import {
  getUtagAuthObject,
  getUtagNeedStates,
  getUtagSessionObject,
} from "../../utils/utagSession";

// Interface for ResultsLandingPage State
interface ResultsLandingPageState {
  isPopupOpen: boolean;
  loading: boolean;
  result: any;
  error: object;
  isLangPopupOpen: boolean;
  contentTypeId: string;
  isTooltipOpen: boolean;
  isDetailsVisible: boolean;
  selectedType: string;
  needStates: any;
  selectedTips: any;
  selectedProducts: any;
  selectedFoods: any;
  selectedReasons: any;
  combinedData: any;
  hitStateData: any;
  hitStateIndex: any;
  hitStateHeading: any;
  isCartVisible: boolean;
  hitStateType: any;
  quantity: number;
  cartProductsList: any;
  successfullyAdded: boolean;
  images: any;
  resultTitle: string;
  resultSubTitle: string;
  userNameState: string;
  showPopup: boolean;
  hitStateSubType: any;
  loading1: boolean;
  loading2: boolean;
  loading3: boolean;
  isSessionExpired: boolean;
  isSaveResultPopupOpen: boolean;
  fallBackImageCard: string;
  fallBackImageProduct: string;
  fallBackImageThumbnail: string;
  resultImage: string;
  foodsImage: string;
  tipsImage: string;
  productsImage: string;
  visibleOnMobile: boolean;
  foodsMBImage: string;
  tipsMBImage: string;
  productsMBImage: string;
  displayOutOfStock: boolean;
  isSurveyShort: boolean;
  productFailedAddToCart: boolean;
}

/**
 * ResultsLandingPage component.
 *
 * @namespace ResultsLandingPage
 */
class ResultsLandingPage extends React.Component<any, ResultsLandingPageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isPopupOpen: false,
      isLangPopupOpen: false,
      contentTypeId: "ms_terms_and_conditions",
      loading: true,
      result: [],
      error: {},
      isTooltipOpen: false,
      isDetailsVisible: false,
      selectedType: "",
      needStates: [],
      selectedTips: [],
      selectedProducts: [],
      selectedFoods: [],
      selectedReasons: [],
      combinedData: [],
      hitStateData: [],
      hitStateIndex: 0,
      hitStateSubType: "",
      isCartVisible: false,
      hitStateType: "",
      quantity: 1,
      cartProductsList: [],
      successfullyAdded: false,
      hitStateHeading: "",
      images: [],
      resultTitle: "",
      resultSubTitle: "",
      userNameState: "",
      showPopup: true,
      loading1:
        localStorage.getItem("surveyType") === "shortSurvey" ? false : true,
      loading2: true,
      loading3:
        localStorage.getItem("surveyType") === "shortSurvey" ? false : true,
      isSessionExpired: false,
      isSaveResultPopupOpen: false,
      fallBackImageCard: "",
      fallBackImageProduct: "",
      fallBackImageThumbnail: "",
      resultImage: "",
      foodsImage: "",
      tipsImage: "",
      productsImage: "",
      visibleOnMobile: false,
      foodsMBImage: "",
      tipsMBImage: "",
      productsMBImage: "",
      displayOutOfStock: false,
      productFailedAddToCart: false,
      isSurveyShort:
        localStorage.getItem("surveyType") === "shortSurvey" ? true : false,
    };
  }

  async componentDidMount() {
    //update to analytics
    // let authObj = getUtagAuthObject();
    // let sessionObj = getUtagSessionObject();
    // let needStatesObj = getUtagNeedStates();

    // let obj = {
    //   page_name: "My Results",
    //   event_name: "results_details",
    // };
    // let updatedObj = _.merge(
    //   localStorage.getItem("user-info") ? authObj : {},
    //   localStorage.getObj("reco-result") ? needStatesObj : {},
    //   sessionObj,
    //   obj
    // );
    // withUtag().then((utag) => utag.view(updatedObj));
    const mediaQuery = window.matchMedia("(max-width: 767px)").matches;
    if (mediaQuery) {
      this.setState({
        visibleOnMobile: true,
      });
    }
    // await setAccessToken(this.props.oktaAuth);
    // await getOrCreateCart();
    // if(sessionStorage.getItem("login-session-expired")){
    //   this.setState({
    //     isSessionExpired:true,
    //     isPopupOpen:true
    //   })
    // }
    //suggestic calls
    // await suggesticCalls();
    // searchByIngredients(["broccoli", "eggs", "spinach"]);
    // fetchProductReview("test1");
    // validateOktaSession(this.props.oktaAuth);

    //handle guest expiry popup
    handleGuestExpiryPopup(this.props);

    //handle save result popup
    let saveResultPopupTime: any;
    if (
      compareExpiryTime() > 0 &&
      !localStorage.getItem("okta-token-storage")
    ) {
      saveResultPopupTime = setTimeout(() => {
        this.setState({
          isPopupOpen: true,
          isSaveResultPopupOpen: true,
        });
      }, compareExpiryTime() * 1000);
    }

    //clear the timeouts set when user get logged in
    if (localStorage.getItem("okta-token-storage")) {
      sessionStorage.removeItem("guestSaveResultTime");
      clearTimeout(saveResultPopupTime);
    }

    const userResponse: any = localStorage.getItem("user-response");

    if (userResponse) {
      let convertedData = JSON.parse(userResponse);
      if (convertedData && convertedData?.length > 0) {
        this.setState({
          userNameState:
            convertedData?.filter(
              (item: any) => item?.contentTypeId === "ms_name"
            )[0]?.values || "",
        });
      }
    } else {
      let user_info: any = localStorage.getItem("user-info");
      let convertedData = JSON.parse(user_info);
      if (convertedData && !_.isEmpty(convertedData)) {
        this.setState({
          userNameState: convertedData?.givenName || "",
        });
      }
    }

    //suggestic calls
    // if (!localStorage.getItem("sg-user")) {
    //   uniqueUserId();
    // }
    // await suggesticCalls();

    //mock-response
    // const dataResponse = _.cloneDeep(response?.data?.getRecommendation);

    const resp = localStorage.getObj("reco-result");

    const dataResponse = _.cloneDeep(
      resp?.data?.getRecommendation || resp?.data?.getRecommendationById
    );

    if (dataResponse && dataResponse.length > 0) {
      //Need states are created and the first one is set as default

      const getNeedStateData: any = getNeedStatesInfo("ms_result_landing_page");

      let needStateArray: any = [];
      getNeedStateData?.then((response: any) => {
        this.setState({
          resultTitle: response?.result_title || "",
          resultSubTitle: this.state.isSurveyShort
            ? response?.result_subtitle[1] || ""
            : response?.result_subtitle[0] || "",
          resultImage: response?.result_image?.url || "",
          fallBackImageCard: response?.fallbackimagecard?.url || "",
          fallBackImageProduct: response?.fallbackimageproduct?.url || "",
          fallBackImageThumbnail: response?.fallbackimagethumbnail?.url || "",
          foodsImage: response?.food_banner_for_desktop?.url || "",
          tipsImage: response?.tips_banner_for_desktop?.url || "",
          productsImage: response?.products_banner_for_desktop?.url || "",
          foodsMBImage: response?.food_banner_for_phone?.url || "",
          tipsMBImage: response?.tips_banner_for_phone?.url || "",
          productsMBImage: response?.products_banner_for_phone?.url || "",
        });
        localStorage.setObj("results-info", response);

        let needState = response?.need_state;
        const transform = (x: any) => x.replaceAll("_", "-");
        needState &&
          Object?.keys(needState)?.forEach((key) => {
            const val = needState[key];
            delete needState[key];
            needState[transform(key)] = val;
          });
        
          if (needState && !_.isEmpty(needState)) {
  for (let index = 0; index < dataResponse?.length; index++) {
    let Obj: any = {};
    Obj.name = dataResponse[index]?.name || "";

    const resultName = dataResponse[index]?.name;
    const needStateEntry = resultName ? needState[resultName] : undefined;

    Obj.displayName = needStateEntry?.[0] || "";
    Obj.imageSrc = needStateEntry?.[3] || "";
    Obj.info = this.state.isSurveyShort
      ? needStateEntry?.[2] || ""
      : needStateEntry?.[1] || "";

    needStateArray.push(Obj);
  }

  needStateArray?.forEach(function (item: { isSelected: boolean }) {
    item.isSelected = false;
  });

  if (needStateArray && needStateArray.length > 0) {
    needStateArray[0].isSelected = true;
  }

  this.setState(
    {
      needStates: needStateArray,
    },
    () => {
      window.history.replaceState(
        null,
        "My Results",
        `/results/#${
          this.state.needStates?.filter(
            (item: any) => item?.isSelected === true
          )[0]?.name
        }`
      );

      let authObj = getUtagAuthObject();
      let sessionObj = getUtagSessionObject();
      let needStatesObj = getUtagNeedStates();

      let obj = {
        page_name: "My Results",
        wellness_resultsCategory:
          this.state.needStates?.filter(
            (item: any) => item?.isSelected === true
          )[0]?.name || "",
      };

      let updatedObj = _.merge(
        localStorage.getItem("user-info") ? authObj : {},
        localStorage.getObj("reco-result") ? needStatesObj : {},
        sessionObj,
        obj
      );

      withUtag().then((utag) => utag.link(updatedObj));
    }
  );
}
      });

      if (
        sessionStorage.getItem("languageTypeOfApp") !== null &&
        sessionStorage.getItem("languageTypeOfApp") !==
          localStorage.getItem("results-language")
      ) {
        await setAccessToken(this.props.oktaAuth);
        // await cartMergingCall();

        await getOrCreateCart().then(async () => {
          if (
            localStorage.getItem("cartId") &&
            localStorage.getItem("okta-token-storage")
          ) {
            await cartMergingCall();
          }
        });
        if (!localStorage.getItem("sg-user")) {
          uniqueUserId();
        }
        await suggesticCalls();

        let self = this;
        const defaultNeedState = dataResponse[0]?.name;

        // await suggesticCalls();

        let groupedReasonsData = getGroupedReasonsData(dataResponse);
        groupedReasonsData.then((response) => {
          let defaultReasons: any = response?.filter(
            (item: any) => item?.name === defaultNeedState
          )[0];

          this.setState({
            combinedData: { ...this.state.combinedData, reasons: response },
            selectedReasons: defaultReasons?.reasonsData || [],
          });
          localStorage.setObj("results", this.state.combinedData);
        });

        let groupedFoodsData = getGroupedFoodsData(
          dataResponse,
          function (resp: any) {
            let defaultFoods: any = resp?.filter(
              (item: any) => item?.name === defaultNeedState
            )[0];
            self.setState({
              combinedData: {
                ...self.state.combinedData,
                foods: resp,
              },
              selectedFoods: defaultFoods?.foodsCompleteData?.foodsEat || [],
              loading1: false,
            });
            localStorage.setObj("results", self.state.combinedData);
          }
        );
        let groupedProductsData = getGroupedProductsData(
          dataResponse,
          function (resp: any) {
            let defaultProducts: any = resp?.filter(
              (item: any) => item?.name === defaultNeedState
            )?.[0];
            const filteredProducts = _.filter(
              defaultProducts?.productsCompleteData.slice(0, 3),
              (item: any) =>
                !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
            );

            self.setState({
              combinedData: {
                ...self.state.combinedData,
                products: resp,
              },
              selectedProducts: self.state.isSurveyShort
                ? filteredProducts || []
                : defaultProducts?.productsCompleteData.slice(0, 1) || [],
              loading2: false,
            });
            localStorage.setObj("results", self.state.combinedData);
          }
        );
        let groupedTipsData = getGroupedTipsData(
          dataResponse,
          function (resp: any) {
            let defaultTips: any = resp?.filter(
              (item: any) => item?.name === defaultNeedState
            )?.[0];
            self.setState({
              combinedData: {
                ...self.state.combinedData,
                tips: resp,
              },
              selectedTips: defaultTips?.tipsData || [],
              loading3: false,
            });
            localStorage.setObj("results", self.state.combinedData);
          }
        );
      } else {
        const self = this;
        //data from local storage
        let storageData: any = localStorage.getObj("results");
        const defaultNeedState = dataResponse[0]?.name;
        //data from props
        const propsData =
          this.props &&
          this.props.location &&
          this.props.location.state &&
          this.props.location.state.data;

        if (propsData) {
          let defaultProducts: any = propsData?.products?.filter(
            (item: any) => item?.name === defaultNeedState
          )?.[0];

          let defaultTips: any = propsData?.tips?.filter(
            (item: any) => item?.name === defaultNeedState
          )?.[0];

          let defaultFoods: any = propsData?.foods?.filter(
            (item: any) => item?.name === defaultNeedState
          )[0];

          let defaultReasons: any = propsData?.reasons?.filter(
            (item: any) => item?.name === defaultNeedState
          )[0];

          const filteredProducts = _.filter(
            defaultProducts?.productsCompleteData.slice(0, 3),
            (item: any) =>
              !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
          );

          this.setState({
            combinedData: propsData,
            selectedTips: defaultTips?.tipsData || [],
            selectedProducts: this.state.isSurveyShort
              ? filteredProducts || []
              : defaultProducts?.productsCompleteData.slice(0, 1) || [],
            selectedFoods: defaultFoods?.foodsCompleteData?.foodsEat || [],
            selectedReasons: defaultReasons?.reasonsData || [],
            loading1: false,
            loading2: false,
            loading3: false,
          });
        } else if (storageData) {
          let defaultProducts: any = storageData?.products?.filter(
            (item: any) => item?.name === defaultNeedState
          )?.[0];

          let defaultTips: any = storageData?.tips?.filter(
            (item: any) => item?.name === defaultNeedState
          )?.[0];

          let defaultFoods: any = storageData?.foods?.filter(
            (item: any) => item?.name === defaultNeedState
          )[0];

          let defaultReasons: any = storageData?.reasons?.filter(
            (item: any) => item?.name === defaultNeedState
          )[0];

          const filteredProducts = _.filter(
            defaultProducts?.productsCompleteData.slice(0, 3),
            (item: any) =>
              !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
          );
          self.setState({
            combinedData: storageData,
            selectedTips: defaultTips?.tipsData || [],
            selectedProducts: this.state.isSurveyShort
              ? filteredProducts || []
              : defaultProducts?.productsCompleteData.slice(0, 1) || [],
            selectedFoods: defaultFoods?.foodsCompleteData?.foodsEat || [],
            selectedReasons: defaultReasons?.reasonsData || [],
            loading1: false,
            loading2: false,
            loading3: false,
          });
        } else {
          await setAccessToken(this.props.oktaAuth);
          await getOrCreateCart().then(async () => {
            if (
              localStorage.getItem("cartId") &&
              localStorage.getItem("okta-token-storage")
            ) {
              await cartMergingCall();
            }
          });
          await suggesticCalls();
          if (!localStorage.getItem("sg-user")) {
            uniqueUserId();
          }
          // await suggesticCalls();

          //data for reasons is fetched and stored in combined array
          let groupedReasonsData = getGroupedReasonsData(dataResponse);
          groupedReasonsData.then((response) => {
            let defaultReasons: any = response?.filter(
              (item: any) => item?.name === defaultNeedState
            )[0];

            this.setState({
              combinedData: { ...this.state.combinedData, reasons: response },
              selectedReasons: defaultReasons?.reasonsData || [],
            });
            localStorage.setObj("results", this.state.combinedData);
          });

          //data for foods is fetched and stored in combined array
          let groupedFoodsData = getGroupedFoodsData(
            dataResponse,
            function (resp: any) {
              let defaultFoods: any = resp?.filter(
                (item: any) => item?.name === defaultNeedState
              )[0];
              self.setState({
                combinedData: {
                  ...self.state.combinedData,
                  foods: resp,
                },
                selectedFoods: defaultFoods?.foodsCompleteData?.foodsEat || [],
                loading1: false,
              });
              localStorage.setObj("results", self.state.combinedData);
            }
          );

          //data for products is fetched and stored in combined array
          let groupedProductsData = getGroupedProductsData(
            dataResponse,
            function (resp: any) {
              let defaultProducts: any = resp?.filter(
                (item: any) => item?.name === defaultNeedState
              )?.[0];

              const filteredProducts = _.filter(
                defaultProducts?.productsCompleteData.slice(0, 3),
                (item: any) =>
                  !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
              );
              self.setState({
                combinedData: {
                  ...self.state.combinedData,
                  products: resp,
                },
                selectedProducts: self.state.isSurveyShort
                  ? filteredProducts || []
                  : defaultProducts?.productsCompleteData.slice(0, 1) || [],
                loading2: false,
              });
              localStorage.setObj("results", self.state.combinedData);
            }
          );

          //data for tips is fetched and stored in combined array
          let groupedTipsData = getGroupedTipsData(
            dataResponse,
            function (resp: any) {
              let defaultTips: any = resp?.filter(
                (item: any) => item?.name === defaultNeedState
              )?.[0];
              self.setState({
                combinedData: {
                  ...self.state.combinedData,
                  tips: resp,
                },
                selectedTips: defaultTips?.tipsData || [],
                loading3: false,
              });
              localStorage.setObj("results", self.state.combinedData);
            }
          );

          const appLanguage: any = sessionStorage.getItem("languageTypeOfApp");
          if (sessionStorage.getItem("languageTypeOfApp") === null) {
            localStorage.setItem("results-language", "en-us");
          } else {
            localStorage.setItem("results-language", appLanguage);
          }
        }

        // let groupedProductsData = getGroupedProductsData(
        //   dataResponse,
        //   function (resp: any) {

        //     self.setState({
        //       combinedData: {
        //         ...self.state.combinedData,
        //         products: resp,
        //       },
        //       selectedProducts: resp[0]?.productsCompleteData,
        //       loading2: false,
        //     });
        //   }
        // );

        // let groupedTipsData = getGroupedTipsData(
        //   dataResponse,
        //   function (resp: any) {
        //     self.setState({
        //       combinedData: {
        //         ...self.state.combinedData,
        //         tips: resp,
        //       },
        //       selectedTips: resp[0]?.tipsData,
        //       loading3: false,
        //     });
        //   }
        // );

        // let groupedFoodsData = getGroupedFoodsData(
        //   dataResponse,
        //   function (resp: any) {
        //     self.setState({
        //       combinedData: {
        //         ...self.state.combinedData,
        //         foods: resp,
        //       },
        //       selectedFoods: resp[0]?.foodsCompleteData?.foodsEat,
        //       loading1: false,
        //     });
        //   }
        // );

        // getGroupedFoodsData(dataResponse);
      }
    } else {
      this.setState({
        loading1: false,
        loading2: false,
        loading3: false,
      });
    }
  }
  //TO:DO Language translation-default state
  async componentWillReceiveProps(props: any) {
    //getContentFormComponenet function is called here
    // validateOktaSession()
    if (props && props.i18n.language) {
      this.setState({
        loading1:
          localStorage.getItem("surveyType") === "shortSurvey" ? false : true,
        loading2: true,
        loading3:
          localStorage.getItem("surveyType") === "shortSurvey" ? false : true,
      });
      const resp = localStorage.getObj("reco-result");
      const dataResponse = _.cloneDeep(
        resp?.data?.getRecommendation || resp?.data?.getRecommendationById
      );
      if (dataResponse && dataResponse.length > 0) {
        //const dataResponse = resp?.data?.getRecommendation;
        const defaultNeedState = dataResponse[0]?.name;
        const getNeedStateData: any = getNeedStatesInfo(
          "ms_result_landing_page"
        );

        let needStateArray: any = [];
        getNeedStateData?.then((response: any) => {
          this.setState({
            resultTitle: response?.result_title || "",
            resultSubTitle: this.state.isSurveyShort
              ? response?.result_subtitle[1] || ""
              : response?.result_subtitle[0] || "",
            resultImage: response?.result_image?.url || "",
            fallBackImageCard: response?.fallbackimagecard?.url || "",
            fallBackImageProduct: response?.fallbackimageproduct?.url || "",
            fallBackImageThumbnail: response?.fallbackimagethumbnail?.url || "",
            foodsImage: response?.food_banner_for_desktop?.url || "",
            tipsImage: response?.tips_banner_for_desktop?.url || "",
            productsImage: response?.products_banner_for_desktop?.url || "",
            foodsMBImage: response?.food_banner_for_phone?.url || "",
            tipsMBImage: response?.tips_banner_for_phone?.url || "",
            productsMBImage: response?.products_banner_for_phone?.url || "",
          });
          localStorage.setObj("results-info", response);

          let needState = response?.need_state;
          const transform = (x: any) => x.replaceAll("_", "-");
          needState &&
            Object?.keys(needState)?.forEach((key) => {
              const val = needState[key];
              delete needState[key];
              needState[transform(key)] = val;
            });
          if (needState && !_.isEmpty(needState)) {
            for (let index = 0; index < dataResponse?.length; index++) {
              let Obj: any = {};
              Obj.name = dataResponse[index]?.name || "";

              const resultName = dataResponse[index]?.name;
              const needStateEntry = resultName ? needState[resultName] : undefined;

              Obj.displayName = needStateEntry?.[0] || "";
              // Obj.displayName = formattedText(dataResponse[index]?.name);
              Obj.imageSrc = needStateEntry?.[3] || "";
              Obj.info = self.state.isSurveyShort
                ? needStateEntry?.[2] || ""
                : needStateEntry?.[1] || "";
              needStateArray.push(Obj);
            }
            needStateArray?.forEach(function (item: { isSelected: boolean }) {
              item.isSelected = false;
            });
            if (needStateArray && needStateArray.length > 0) {
              needStateArray[0].isSelected = true;
            }
            this.setState(
              {
                needStates: needStateArray,
              },
              () => {
                window.history.replaceState(
                  null,
                  "My Results",
                  `/results/#${
                    this.state.needStates?.filter(
                      (item: any) => item?.isSelected === true
                    )[0]?.name
                  }`
                );
                let authObj = getUtagAuthObject();
                let sessionObj = getUtagSessionObject();
                let needStatesObj = getUtagNeedStates();

                let obj = {
                  page_name: "My Results",
                  wellness_resultsCategory:
                    this.state.needStates?.filter(
                      (item: any) => item?.isSelected === true
                    )[0]?.name || "",
                };
                let updatedObj = _.merge(
                  localStorage.getItem("user-info") ? authObj : {},
                  localStorage.getObj("reco-result") ? needStatesObj : {},
                  sessionObj,
                  obj
                );
                withUtag().then((utag) => utag.link(updatedObj));
              }
            );
          }
          // this.setState({ needStates: needStateArray }, () => {
          //   let arr: any = [];
          //   this.state?.needStates?.forEach((element: any) => {
          //     arr.push(element?.imageSrc);
          //   });
          //   this.setState({
          //     combinedData: { ...this.state?.combinedData, needStateImages: arr },
          //   });
          // });
        });

        let self = this;

        await setAccessToken(this.props.oktaAuth);
        await getOrCreateCart().then(async () => {
          if (
            localStorage.getItem("cartId") &&
            localStorage.getItem("okta-token-storage")
          ) {
            await cartMergingCall();
          }
        });
        await suggesticCalls();
        if (!localStorage.getItem("sg-user")) {
          uniqueUserId();
        }

        let groupedReasonsData = getGroupedReasonsData(dataResponse);
        groupedReasonsData.then((response) => {
          let defaultReasons: any = response?.filter(
            (item: any) => item?.name === defaultNeedState
          )[0];

          this.setState(
            {
              combinedData: { ...this.state.combinedData, reasons: response },
              selectedReasons: defaultReasons?.reasonsData || [],
            },
            () => {
              localStorage.setObj("results", this.state.combinedData);
            }
          );
        });

        let groupedFoodsData = getGroupedFoodsData(
          dataResponse,
          function (resp: any) {
            let defaultFoods: any = resp?.filter(
              (item: any) => item?.name === defaultNeedState
            )[0];

            self.setState(
              {
                combinedData: {
                  ...self.state.combinedData,
                  foods: resp,
                },
                selectedFoods: defaultFoods?.foodsCompleteData?.foodsEat || [],
                loading1: false,
              },
              () => {
                localStorage.setObj("results", self.state.combinedData);
              }
            );
          }
        );
        let groupedProductsData = getGroupedProductsData(
          dataResponse,
          function (resp: any) {
            let defaultProducts: any = resp?.filter(
              (item: any) => item?.name === defaultNeedState
            )?.[0];

            const filteredProducts = _.filter(
              defaultProducts?.productsCompleteData.slice(0, 3),
              (item: any) =>
                !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
            );

            self.setState(
              {
                combinedData: {
                  ...self.state.combinedData,
                  products: resp,
                },
                selectedProducts: self.state.isSurveyShort
                  ? filteredProducts || []
                  : defaultProducts?.productsCompleteData.slice(0, 1) || [],
                loading2: false,
              },
              () => {
                localStorage.setObj("results", self.state.combinedData);
              }
            );
          }
        );
        let groupedTipsData = getGroupedTipsData(
          dataResponse,
          function (resp: any) {
            let defaultTips: any = resp?.filter(
              (item: any) => item?.name === defaultNeedState
            )?.[0];

            self.setState(
              {
                combinedData: {
                  ...self.state.combinedData,
                  tips: resp,
                },
                selectedTips: defaultTips?.tipsData || [],
                loading3: false,
              },
              () => {
                localStorage.setObj("results", self.state.combinedData);
              }
            );
          }
        );

        //localStorage.setObj("results", self.state.combinedData);
        const appLanguage: any = sessionStorage.getItem("languageTypeOfApp");
        if (sessionStorage.getItem("languageTypeOfApp") === null) {
          localStorage.setItem("results-language", "en-us");
        } else {
          localStorage.setItem("results-language", appLanguage);
        }
      }
    }
  }

  componentDidUpdate() {
    validateOktaSession(this.props.oktaAuth);
    if (
      !localStorage.getItem("reco-result") &&
      !localStorage.getItem("user-response")
    ) {
      sessionStorage.removeItem("foundationalPageCount");
      this.props.history.push("/foundational");
    }
    if (
      localStorage.getItem("guestExpiryTime") &&
      compareGuestExpiryTime() < 0
    ) {
      clearSession(this.props);
    }

    //enables login session expiry popup
    if (
      sessionStorage.getItem("login-session-expired") &&
      !this.state.isSessionExpired &&
      !(localStorage?.getItem("okta-token-storage") !== "{}")
    ) {
      this.setState({
        isSessionExpired: true,
        isPopupOpen: true,
      });
    }
  }

  // componentWillReceiveProps() {
  //   if (sessionStorage.getItem("login-session-expired")) {
  //     this.setState({
  //       isSessionExpired: true,
  //       isPopupOpen: true,
  //     });
  //   }
  // }

  getCartProductsList = async () => {
    await getCartEntries().then((response: any) => {
      let entries: any = [];
      response &&
        response.entries.map((item: any) => {
          entries.push(item);
        });
      // this.setState({
      //   cartProductsList: entries,
      // });
    });
  };

  handleViewMore(type: string, e?: any) {
    this.props.history.push(`/summary/#${type?.toLowerCase()}`, {
      summaryType: type,
      data: this.state.combinedData,
    });
  }
  handleSeeMore = (
    type: string,
    index?: number,
    heading?: string,
    subType?: string,
    e?: any
  ) => {
    if (type === "tips") {
      this.setState({
        hitStateData: this.state?.selectedTips?.slice(0, 3),
        hitStateIndex: index,
        hitStateType: type,
        hitStateHeading: heading,
        hitStateSubType: "",
      });
    }
    if (type === "product") {
      const filteredProducts = _.filter(
        this.state.selectedProducts?.slice(0, 3),
        (item: any) => !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
      );

      this.setState({
        hitStateData: this.state.isSurveyShort
          ? filteredProducts || []
          : this.state?.selectedProducts?.slice(0, 1) || [],
        hitStateIndex: index,
        hitStateType: type,
        hitStateSubType: "",
      });
    }

    if (type === "food") {
      this.setState({
        hitStateData: this.state?.selectedFoods?.slice(0, 4),
        hitStateIndex: index,
        hitStateType: type,
        hitStateHeading: heading,
        hitStateSubType: subType,
      });
    }
    this.setState({
      isDetailsVisible: true,
      selectedType: type,
    });
  };
  handleDeatilsClose = () => {
    this.setState({
      isDetailsVisible: false,
    });
  };

  handleOutOfStock = () => {
    this.setState(
      {
        displayOutOfStock: true,
      },
      () => setTimeout(() => this.setState({ displayOutOfStock: false }), 3000)
    );
  };

  /**
   * This function is used to handle change in need state
   * @value - any
   *
   */
  handleChange = (value: any, e?: any) => {
    const tips = this.state?.combinedData?.tips;
    const foods = this.state?.combinedData?.foods;
    const products = this.state.combinedData?.products;
    const reasons = this.state.combinedData?.reasons;

    let tipsFound = false;
    tips?.forEach((element: any) => {
      if (element?.name === value) {
        tipsFound = true;
        this.setState({ selectedTips: element?.tipsData });
      }
    });
    if (tipsFound === false) {
      this.setState({ selectedTips: [] });
    }
    let prodsFound = false;
    let needStateProductsShortSurvey: any = [];
    let needStateProductsLongSurvey: any = [];
    products?.forEach((element: any) => {
      if (element?.name === value) {
        prodsFound = true;
        if (this.state.isSurveyShort) {
          needStateProductsShortSurvey =
            [...(element?.productsCompleteData?.slice(0, 3) || [])];
        } else {
          needStateProductsLongSurvey =
            [...(element?.productsCompleteData?.slice(0, 1) || [])];
        }
        const filteredProducts = _.filter(
          needStateProductsShortSurvey,
          (item: any) =>
            !_.isNil(item?.data) && item?.data?.name !== "NOT FOUND"
        );
        this.setState({
          selectedProducts: this.state.isSurveyShort
            ? filteredProducts || []
            : needStateProductsLongSurvey || [],
        });
      }
    });
    if (prodsFound === false) {
      this.setState({ selectedProducts: [] });
    }

    let foodsFound = false;
    foods?.forEach((element: any) => {
      if (element?.name === value) {
        foodsFound = true;
        this.setState({
          selectedFoods: element?.foodsCompleteData?.foodsEat,
        });
      }
    });

    if (foodsFound === false) {
      this.setState({ selectedFoods: [] });
    }

    let reasonsFound = false;
    reasons?.forEach((element: any) => {
      reasonsFound = true;
      if (element?.name === value) {
        this.setState({ selectedReasons: element.reasonsData });
      }
    });

    if (reasonsFound === false) {
      this.setState({ selectedReasons: [] });
    }
    const data = this.state?.needStates;
    data?.forEach((element: any) => {
      if (element?.name === value) {
        element.isSelected = true;
      } else {
        element.isSelected = false;
      }
    });
    this.setState({ needStates: data }, () => {
      window.history.replaceState(
        null,
        "My Results",
        `/results/#${
          this.state.needStates?.filter(
            (item: any) => item?.isSelected === true
          )[0]?.name
        }`
      );
      let authObj = getUtagAuthObject();
      let sessionObj = getUtagSessionObject();
      let needStatesObj = getUtagNeedStates();

      let obj = {
        page_name: "My Results",
        wellness_resultsCategory:
          this.state.needStates?.filter(
            (item: any) => item?.isSelected === true
          )[0]?.name || "",
      };
      let updatedObj = _.merge(
        localStorage.getItem("user-info") ? authObj : {},
        localStorage.getObj("reco-result") ? needStatesObj : {},
        sessionObj,
        obj
      );
      withUtag().then((utag) => utag.link(updatedObj));
    });
  };

  /**
   * This function is used to handle change in header selection
   * @data - any
   *
   */

  handleHeaderSelection = (data: any) => {
    if (data === "Tips") {
      this.props.history.push(`/summary/#tips`, {
        summaryType: "Tips",
        data: this.state?.combinedData,
      });
    }
    if (data === "Foods") {
      this.props.history.push(`/summary/#foods`, {
        summaryType: "Foods",
        data: this.state?.combinedData,
      });
    }
    if (data === "Products") {
      this.props.history.push(`/summary/#products`, {
        summaryType: "Products",
        data: this.state?.combinedData,
      });
    }
    if (data === "Results") {
      this.props.history.push("/results", {
        summaryType: "Results",
      });
    }
  };

  handleCartClick = (e?: any) => {
    this.setState({
      isCartVisible: true,
    });
  };
  handleCartClose = () => {
    this.setState({
      isCartVisible: false,
    });
  };

  increaseQuantity = () => {
    this.setState({
      quantity: this.state.quantity + 1,
    });
  };
  decreaseQuantity = () => {
    if (this.state.quantity && this.state.quantity > 1) {
      this.setState({
        quantity: this.state.quantity - 1,
      });
    }
  };

  handleAddtoCart = (productCode: number) => {
    addCartEntries(productCode, this.state.quantity).then((response: any) => {
      if (response) {
        //cart addition event
        let authObj = getUtagAuthObject();
        let sessionObj = getUtagSessionObject();
        let needStatesObj = getUtagNeedStates();

        let obj = {
          page_name: "My Results",
          event_name: "cart_addition",
          product_brand: [response?.entry?.product?.brandName],
          ...(response?.entry?.value?.businessVolume && {
            product_businessVolume: [
              response?.entry?.value?.businessVolume?.toString(),
            ],
          }),
          product_id: [response?.entry?.product?.code],
          product_name: [response?.entry?.product?.name],
          ...(response?.entry?.value?.pointValue && {
            product_pointValue: [response?.entry?.value?.pointValue.toString()],
          }),
          product_referrer: ["wellness-guide"],
          product_unitPrice: [response?.entry?.basePrice?.value?.toString()],
          product_units: [response?.quantityAdded?.toString()],
        };
        let updatedObj = _.merge(
          localStorage.getItem("user-info") ? authObj : {},
          localStorage.getObj("reco-result") ? needStatesObj : {},
          sessionObj,
          obj
        );
        withUtag().then((utag) => utag.link(updatedObj));

        this.getCartProductsList();
        this.setState(
          {
            successfullyAdded: true,
            quantity: 1,
          },
          () =>
            setTimeout(() => this.setState({ successfullyAdded: false }), 3000)
        );
      } else {
        this.setState(
          {
            productFailedAddToCart: true,
          },
          () => setTimeout(() => this.setState({ productFailedAddToCart: false }), 3000)
        );
      }
    });
  };

  handleProductPhrases = (arr: any) => {
    if (arr.length > 2) {
      let str = "";
      str += `<p> ${arr?.[0]} `;
      if (arr?.length === 3) {
        str += `<span style="font-weight:bold"> ${arr?.[1]}, </span>`;
      } else {
        let subArr = arr?.slice(1, arr?.length - 2);
        let subStr = subArr?.join(", ");
        str += `<span style="font-weight:bold">${subStr}</span>`;
        str += ` and <span style="font-weight:bold">${
          arr?.[arr?.length - 2]
        }, </span>`;
      }
      str += `${arr?.[arr?.length - 1]}</p>`;
      return str;
    } else {
      return _.capitalize(arr?.[arr?.length - 1]);
    }
  };

  closePopup = () => {
    this.setState(
      {
        isPopupOpen: false,
        showPopup: false,
      },
      () => {
        sessionStorage.setItem("saveResults", "false");
        // sessionStorage.removeItem("login-session-expired");

        //if user denied to relogin then session gets cleared
        if (sessionStorage.getItem("login-session-expired")) {
          let currentLanguage =
            sessionStorage.getItem("languageTypeOfApp") || "en-us";
          localStorage.clear();
          sessionStorage.clear();
          sessionStorage.setItem("languageTypeOfApp", currentLanguage);
          this.props.history.replace("/home");
          localStorage.setItem("logout", "true");
        }
      }
    );
  };

  getSettingsForThumbnails = (
    productImages: any,
    fallBackImageThumbnail: string
  ) => {
    let thumbnailImages: any = [];
    productImages
      ?.filter((element: any) => element?.format === "thumbnail")
      ?.map((item: any) =>
        thumbnailImages.push({
          imageSrc: `${process.env.REACT_APP_IMGAE_BASE_URL}` + item?.publicUrl,
        })
      );
    let settings = {
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      dotsClass: "slick-dots slick-thumb",
      responsive: [
        {
          breakpoint: 800,
          settings: {
            arrows: true,
          },
        },
        {
          breakpoint: 2000,
          settings: {
            vertical: true,
            verticalSwiping: true,
            arrows: false,
            customPaging: function (i: any) {
              return (
                <div className="icon thumbnail-img">
                  <img
                    src={
                      thumbnailImages?.[i]?.imageSrc
                        ? thumbnailImages?.[i]?.imageSrc
                        : fallBackImageThumbnail
                    }
                    alt=""
                  />
                </div>
              );
            },
          },
        },
      ],
    };
    return settings;
  };

  render() {
    const {
      isDetailsVisible,
      selectedType,
      hitStateData,
      hitStateIndex,
      needStates,
      isCartVisible,
      hitStateType,
      hitStateHeading,
      hitStateSubType,
      quantity,
      cartProductsList,
      successfullyAdded,
      resultTitle,
      resultSubTitle,
      userNameState,
      selectedFoods,
      resultImage,
      productsImage,
      tipsImage,
      foodsImage,
      visibleOnMobile,
      foodsMBImage,
      tipsMBImage,
      productsMBImage,
      displayOutOfStock,
      fallBackImageThumbnail,
      productFailedAddToCart,
    } = this.state;
    //let settings: any;

    // let self = this;
    // if (
    //   this.state.selectedProducts &&
    //   this.state.selectedProducts.length > 0 &&
    //   this.state.selectedProducts[0]?.data &&
    //   this?.state?.fallBackImageThumbnail
    // ) {
    //   let thumbnailImages: any = [];
    //   this.state?.selectedProducts[0]?.data?.images
    //     ?.filter((element: any) => element?.format === "thumbnail")
    //     ?.map((item: any) =>
    //       thumbnailImages.push({
    //         imageSrc:
    //           `${process.env.REACT_APP_IMGAE_BASE_URL}` + item?.publicUrl,
    //       })
    //     );

    //   settings = {
    //     dots: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dotsClass: "slick-dots slick-thumb",
    //     responsive: [
    //       {
    //         breakpoint: 800,
    //         settings: {
    //           arrows: true,
    //         },
    //       },
    //       {
    //         breakpoint: 2000,
    //         settings: {
    //           vertical: true,
    //           verticalSwiping: true,
    //           arrows: false,
    //           customPaging: function (i: any) {
    //             return (
    //               <div className="icon thumbnail-img">
    //                 <img
    //                   src={
    //                     thumbnailImages?.[i]?.imageSrc
    //                       ? thumbnailImages?.[i]?.imageSrc
    //                       : self.state.fallBackImageThumbnail
    //                   }
    //                   alt=""
    //                 />
    //                 {/* <img
    //                   src={thumbnailImages?.[i]?.imageSrc}
    //                   alt=""
    //                   onError={(e: any) => {
    //                     e.currentTarget.src =
    //                       self?.state.fallBackImageThumbnail;
    //                   }}
    //                 /> */}
    //                 {/* <img src={thumbnailImages?.[i]?.imageSrc} alt="" /> */}
    //               </div>
    //             );
    //           },
    //         },
    //       },
    //     ],
    //   };
    // }

    // Card Settings for slider
    var cardSettings = {
      responsive: [
        {
          breakpoint: 800,
          settings: {
            dots: true,
            speed: 500,
            slidesToShow: 1.05,
            // slidesToScroll: 1,
            arrows: false,
            dotsClass: "slick-dots slick-thumb",
            centerMode: true,
            centerPadding: "30px",
            infinite: false,
          },
        },
      ],
    };
    return (
      <div
        className={
          "result-landing-container"
          // isCartVisible || isDetailsVisible
          //   ? "result-landing-container no-scroll"
          //   : "result-landing-container"
        }
      >
        {/* Details container Start */}
        {isDetailsVisible && (
            <DetailsComponent
            {...this.props}
            handleClose={this.handleDeatilsClose}
            show={isDetailsVisible}
            selectedType={selectedType}
            hitStateData={hitStateData}
            hitStateIndex={hitStateIndex}
            hitStateType={hitStateType}
            hitStateSubType={hitStateSubType}
            // handleDetailsCart={(productCode: number) => {
            //   this.handleAddtoCart(productCode);
            // }}
            hitStateHeading={hitStateHeading}
          />
        )}

        {/* Details container Ends */}

        {/* Save Results Popup Start */}
        {this.state.isSaveResultPopupOpen && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.save_result")}
            popupMessage={this.props.t("common.save_result_message")}
            popupFirstButton={this.props.t("common.sign_in_to_amway")}
            popupFirstButtonType="sign-in"
          />
        )}

        {this.state.isSessionExpired && (
          <SaveResultsPopup
            {...this.props}
            open={this.state.isPopupOpen}
            close={this.closePopup}
            popupTitle={this.props.t("common.welcome_back")}
            popupMessage={this.props.t("common.login_session_expiry_message")}
            popupFirstButton={this.props.t("common.sign_in")}
            popupFirstButtonType="sign-in"
            // popupSecondButton="Take the Quiz"
          />
        )}

        {/* <SaveResultsPopup
          {...this.props}
          open={this.state.isPopupOpen}
          close={this.closePopup}
          popupTitle="Save your Results!"
          popupMessage="Sorry to interrupt, but you may want to create an account.That way, we can save your recommendations for the next time you visit Wellness."
          popupFirstButton="Sign In to Amway"
        /> */}

        {/* Save Results Popup Ends */}

        {/* Cart Component Start */}
        {isCartVisible ? (
          <CartComponent
            {...this.props}
            handleClose={this.handleCartClose}
            show={isCartVisible}
          />
        ) : null}
        {/* Cart Component Ends */}

        {/* Add to Cart Success Message Start */}
        {successfullyAdded ? (
          <MessageStrip
            messageText={this.props.t("common.user_added_product_to_cart")}
          />
        ) : null}
        {/* Add to Cart Success Message Ends */}

        {/* Display out of stock Message Start */}
        {displayOutOfStock ? (
          <MessageStrip
            messageText={this.props.t("common.out_of_stock")}
            warning={true}
          />
        ) : null}
        {/* display out of stock Message Ends */}

        {/* Display product fail Message Start */}
        {productFailedAddToCart ? (
          <MessageStrip
            messageText={this.props.t("common.product_failed_add_to_cart")}
            warning={true}
          />        ) : null}
        {/* display out of stock Message Ends */}

        {/* Header Container Start */}

        <div className="header-container">
          {/* {this.state.loading1 === false &&
            this.state.loading2 === false &&
            this.state.loading3 === false && ( */}

          <ResultsHeader
            {...this.props}
            foodsLoader={this.state.loading1}
            productsLoader={this.state.loading2}
            tipsLoader={this.state.loading3}
            //selectedType={this.props.location.state}
            handleCallBack={(data: any) => this.handleHeaderSelection(data)}
            handleCartClick={this.handleCartClick}
            handleCartKeyPress={(e: any) => {
              if (e.key === "Enter") {
                this.handleCartClick(e);
              }
            }}
          />

          {/* )} */}
          {/* )} */}

          {/* <ResultsHeader handleCartClick={this.handleCartClick} /> */}
          <div className="result-bg-container">
            {resultImage && (
              <div
                className="icon result-bg-img"
                style={{ backgroundImage: `url(${resultImage})` }}
              ></div>
            )}
            {/* Result User Info Start */}
            <div className="result-title-wrapper">
              {resultTitle && userNameState && (
                <div className="user-name">
                  {resultTitle.replace("$Name", userNameState)}
                </div>
              )}
              {resultSubTitle && (
                <div className="details">
                  {resultSubTitle}
                  {/* We’ve curated these recommendations to cater to your wellness
                goals and improve your overall health */}
                </div>
              )}
            </div>
            {/* Result User Info Ends */}
            {this.state.loading1 === false &&
              this.state.loading2 === false &&
              this.state.loading3 === false &&
              needStates &&
              needStates.length > 0 &&
              !this.state.isSurveyShort && (
                <div className="results-options-wrapper">
                  {needStates.map((item: any, index: any) => (
                    <div
                      key={index}
                      tabIndex={0}
                      role="button"
                      id={item?.name}
                      className={
                        item?.isSelected ? "options active" : "options "
                      }
                      onClick={() => this.handleChange(item?.name)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleChange(item?.name, e);
                        }
                      }}
                    >
                      <img src={item?.imageSrc} alt=""></img>
                      {/* <span className="icon option-icon"></span> */}
                      <div className="option">{item?.displayName || ""}</div>
                    </div>
                  ))}
                </div>
              )}
          </div>
        </div>
        {/* Header Container Ends */}

        {/* Middle area Start */}

        <div className="middle-area">
          <div className="inner-wrapper">
            {/* details wrapper Start */}
            {this.state.loading1 === false &&
              this.state.loading2 === false &&
              this.state.loading3 === false &&
              needStates &&
              needStates.length > 0 && (
                <div className="details-wrapper">
                  <span className="for-your">
                    {this.props.t("common.for_your")}
                  </span>
                  <div className="details-title">
                    {needStates?.filter(
                      (item: any) => item?.isSelected === true
                    )[0]?.displayName || ""}
                  </div>
                  <div className="details-description">
                    {needStates?.filter(
                      (item: any) => item?.isSelected === true
                    )[0]?.info || ""}
                  </div>
                </div>
              )}

            {this.state.loading1 === true ? (
              <Loader loaderClassName={"loader-wrapper"} />
            ) : (
              needStates &&
              needStates.length > 0 &&
              needStates?.filter((item: any) => item?.isSelected === true)[0]
                ?.name !== "everyday-health" &&
              selectedFoods &&
              selectedFoods.length > 0 &&
              !this.state.isSurveyShort && (
                <div className="food-container">
                  <div className="inner-wrapper">
                    {foodsImage && (
                      <div
                        className="image-wrapper"
                        style={{
                          backgroundImage: visibleOnMobile
                            ? `url(${foodsMBImage})`
                            : `url(${foodsImage})`,
                        }}
                      >
                        <div className="overlay"></div>
                        <span className="heading">
                          {this.props.t("common.foods_to_feast")}
                        </span>
                      </div>
                    )}

                    <FoodComponent
                      {...this.props}
                      colClassName="col-md-3"
                      cardSettings={cardSettings}
                      foodSubType="eat"
                      foodsData={this.state?.selectedFoods?.slice(0, 4)}
                      handleSeeMore={(index: number, heading: string) =>
                        this.handleSeeMore("food", index, heading, "eat")
                      }
                      handleSeeMoreOnKeyPress={(
                        index: number,
                        heading: string,
                        e: any
                      ) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleSeeMore("food", index, heading, "eat", e);
                        }
                      }}
                    />
                    <span
                      tabIndex={0}
                      role="link"
                      className="view-more-link"
                      onClick={() => this.handleViewMore("Foods")}
                      onKeyPress={(e: any) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleViewMore("Foods", e);
                        }
                      }}
                    >
                      {this.props.t("common.view_all_foods")}
                    </span>
                  </div>
                </div>
              )
            )}

            {/* Food Section Ends */}

            {/* Product Section Start */}

            {this.state.loading2 === true ? (
              <Loader loaderClassName={"loader-wrapper"} />
            ) : (
              <div className="product-container">
                <div className="inner-wrapper">
                  {productsImage && (
                    <div
                      className="image-wrapper"
                      style={{
                        backgroundImage: visibleOnMobile
                          ? `url(${productsMBImage})`
                          : `url(${productsImage})`,
                      }}
                    >
                      <div className="overlay"></div>
                      <span className="heading">
                        {this.state.isSurveyShort
                          ? this.props.t("common.best_products")
                          : this.props.t("common.best_product")}
                      </span>
                    </div>
                  )}
                  <div className="detail-wrapper">
                    {!this.state.isSurveyShort ? (
                      <div className="description">
                        {this.state?.selectedProducts &&
                        this.state?.selectedProducts?.length > 0 &&
                        this.state?.selectedProducts[0]?.data
                          ? ReactHtmlParser(
                              this.handleProductPhrases(
                                this.state?.selectedReasons
                              )?.replaceAll("$Name", userNameState || "$Name")
                            )
                          : this.props.t(
                              "common.product_recommendation_message"
                            )}
                      </div>
                    ) : (
                      this.state?.selectedProducts?.length === 0 && (
                        <div className="description">
                          {this.props.t(
                            "common.products_recommendation_message"
                          )}
                        </div>
                      )
                    )}
                    {/* {this.state.selectedProducts &&
                      this.state.selectedProducts.length > 0 &&
                      this.state.selectedProducts.map((item: any) => (
                        <div>{item?.data?.name} </div>
                      ))} */}

                    {this.state.selectedProducts &&
                      this.state.selectedProducts.length > 0 &&
                      this.state.selectedProducts.map(
                        (item: any, index: number) =>
                          item?.data &&
                          this?.state?.fallBackImageProduct &&
                          item?.data &&
                          fallBackImageThumbnail &&
                          item?.data?.name !== "NOT FOUND" && (
                            <div className="product-wrapper bootstrap-wrapper">
                              <div className="inner-wrapper col-md-12 clearfix">
                                <div className="left-wrapper col-md-6 pull-left">
                                  {/* <div className="slider-wrapper clearfix">
                                    <div silder-images-wrapper>
                                    <img
                                      src={this.state.fallBackImageProduct}
                                    ></img>
                                    
                                  </div> */}
                                  <div className="slider-wrapper clearfix">
                                    <div className="silder-images-wrapper">
                                      {item?.data?.images &&
                                      item?.data?.images.length > 0 ? (
                                        <Slider
                                          {...this.getSettingsForThumbnails(
                                            item?.data?.images,
                                            fallBackImageThumbnail
                                          )}
                                        >
                                          {item?.data?.images
                                            ?.filter(
                                              (element: any) =>
                                                element?.format === "product"
                                            )
                                            ?.map(
                                              (item: any, itemIndex: any) => (
                                                <>
                                                  <div
                                                    className="slider-main-img"
                                                    key={itemIndex}
                                                  >
                                                    <img
                                                      tabIndex={-1}
                                                      role="img"
                                                      aria-labelledby="product-image"
                                                      className={"slider-img"}
                                                      src={
                                                        `${process.env.REACT_APP_IMGAE_BASE_URL}` +
                                                        item?.publicUrl
                                                          ? `${process.env.REACT_APP_IMGAE_BASE_URL}` +
                                                            item?.publicUrl
                                                          : this?.state
                                                              ?.fallBackImageProduct
                                                      }
                                                      alt=""
                                                    />
                                                  </div>
                                                </>
                                              )
                                            )}
                                        </Slider>
                                      ) : (
                                        this?.state?.fallBackImageProduct && (
                                          <div className="fallback-main-img">
                                            <img
                                              tabIndex={-1}
                                              role="img"
                                              aria-labelledby="product-image"
                                              className={"fallback-img"}
                                              src={
                                                this?.state
                                                  ?.fallBackImageProduct
                                              }
                                              alt=""
                                            />
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="right-wrapper col-md-6  pull-left">
                                  <div className="product-detail-wrapper clearfix">
                                    <div className="product-detail">
                                      {/* <div className="need-state-icons">
                                      {this.state.combinedData?.needStateImages &&
                                        this.state.combinedData?.needStateImages
                                          .length > 0 &&
                                        this.state.combinedData?.needStateImages.map(
                                          (item: any) => (
                                            <div
                                              className="icon icon-list"
                                              style={{
                                                backgroundImage: item
                                                  ? `url(${item})`
                                                  : `url(${tomatoes})`,
                                              }}
                                            />
                                          )
                                        )}
                                      {/* <div className="icon icon-list"></div>
                                      <div className="icon icon-list"></div>
                                      <div className="icon icon-list"></div> */}
                                      {/* </div> */}
                                      <div
                                        className="product-name"
                                        id="product-image"
                                      >
                                        {item?.data?.name || ""}
                                        {/* n* by Nutrilite™ Less Stress, More Yes – Relax
                                      Gummies */}
                                      </div>
                                      {/* <div className="product-recommended">
                                      30 servings - Recommended use: 2 per day
                                    </div> */}
                                      <div className="rating-star-wrapper">
                                        <StarRatings
                                          //rating={4.88}
                                          rating={
                                            item?.reviews?.Results[0]
                                              ?.ProductStatistics
                                              ?.ReviewStatistics
                                              ?.AverageOverallRating || 0
                                          }
                                          starRatedColor="#F1C400"
                                          numberOfStars={
                                            item?.reviews?.Results[0]
                                              ?.ProductStatistics
                                              ?.ReviewStatistics
                                              ?.OverallRatingRange || 5
                                          }
                                          name="rating"
                                          starDimension="15px"
                                          starSpacing="2px"
                                          // svgIconPath={
                                          //   "M13.8942 5.07885C13.8939 5.07881 13.8936 5.07877 13.8934 5.07873L10.2791 4.55457C10.2789 4.55454 10.2786 4.55451 10.2784 4.55448L10.278 4.55442L10.3498 4.0596C10.2798 4.0496 10.2248 4.0096 10.1948 3.94961L13.8942 5.07885ZM13.8942 5.07885C14.168 5.12128 14.3826 5.30398 14.4629 5.55608L14.4628 5.55609L14.465 5.5626C14.548 5.8117 14.481 6.08659 14.2863 6.27542L14.2853 6.2764L11.6705 8.82633C11.491 8.99394 11.4278 9.22827 11.4604 9.44021L11.4603 9.44022L11.4618 9.44881L12.0817 13.0584L12.0821 13.0604C12.1287 13.3255 12.0224 13.586 11.8048 13.7448L11.8048 13.7448L11.8026 13.7464C11.6836 13.8343 11.539 13.8787 11.3946 13.8787C11.2821 13.8787 11.17 13.8518 11.0732 13.7992L11.0732 13.7992L11.067 13.7959L7.83413 12.0997C7.63479 11.989 7.38112 11.9772 7.16522 12.1026L3.93328 13.7958L3.93087 13.7971C3.6967 13.9214 3.41633 13.9033 3.19385 13.7438C2.97713 13.5849 2.87139 13.3249 2.91791 13.0604L2.91825 13.0584L3.53819 9.44881L3.53827 9.44883L3.5396 9.4402C3.57219 9.22829 3.50899 8.99393 3.32946 8.8263L0.714731 6.2764L0.713719 6.27542C0.518995 6.08659 0.45198 5.81171 0.535019 5.56259L0.535064 5.5626L0.53714 5.55608C0.617248 5.30431 0.831391 5.12176 1.10474 5.07902L4.72099 4.55457C4.72121 4.55454 4.72143 4.55451 4.72165 4.55448L13.8942 5.07885Z"
                                          // }
                                          svgIconPath={
                                            "M13.9695 4.58455L10.3498 4.0596C10.2798 4.0496 10.2248 4.0096 10.1948 3.94961L8.57495 0.664934C8.37497 0.25497 7.96 0 7.50004 0C7.04008 0 6.62511 0.254986 6.42512 0.664934L4.80526 3.94961C4.77527 4.0096 4.72027 4.0496 4.65028 4.0596L1.03059 4.58455C0.575624 4.65454 0.200665 4.96451 0.0606768 5.40447C-0.0843106 5.83944 0.0356789 6.31439 0.365642 6.63437L2.98541 9.18918C3.03541 9.23418 3.05541 9.29918 3.04541 9.36418L2.42546 12.9738C2.34547 13.4288 2.53045 13.8787 2.90043 14.1487C3.27541 14.4187 3.76035 14.4537 4.16531 14.2387L7.40999 12.5388C7.46498 12.5038 7.53498 12.5038 7.59497 12.5388L10.8347 14.2387C11.0097 14.3337 11.2047 14.3787 11.3946 14.3787C11.6396 14.3787 11.8896 14.3037 12.0996 14.1487C12.4695 13.8787 12.6545 13.4288 12.5745 12.9738L11.9546 9.36418C11.9446 9.29918 11.9646 9.23419 12.0146 9.18918L14.6344 6.63437C14.9643 6.31439 15.0843 5.83943 14.9393 5.40447C14.7993 4.96451 14.4244 4.65454 13.9694 4.58455H13.9695Z"
                                          }
                                          svgIconViewBox={"0 0 15 15"}
                                        />
                                        <span className="label">
                                          <span>
                                            {item?.reviews?.Results[0]
                                              ?.ProductStatistics
                                              ?.ReviewStatistics
                                              ?.AverageOverallRating
                                              ? this.state?.selectedProducts[0]?.reviews?.Results[0]?.ProductStatistics?.ReviewStatistics?.AverageOverallRating?.toFixed(
                                                  1
                                                ) + " ("
                                              : "0   ("}
                                          </span>

                                          <span>
                                            {item?.reviews?.Results[0]
                                              ?.ProductStatistics
                                              ?.ReviewStatistics
                                              ?.TotalReviewCount
                                              ? item?.reviews?.Results[0]
                                                  ?.ProductStatistics
                                                  ?.ReviewStatistics
                                                  ?.TotalReviewCount + ") "
                                              : 0 + ") "}
                                          </span>
                                          {this.props.t("common.reviews")}
                                          {/* {this.state.selectedProducts[0]?.reviews
                                            ?.Results[0]?.ProductStatistics
                                            ?.ReviewStatistics
                                            ?.AverageOverallRating +
                                            "  (" +
                                            this.state.selectedProducts[0]?.reviews
                                              ?.Results[0]?.ProductStatistics
                                              ?.ReviewStatistics?.TotalReviewCount +
                                            ") " +
                                            this.props.t("common.reviews")} */}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="product-price">
                                      {item?.data?.price?.formattedValue || ""}
                                    </div>
                                  </div>
                                  <div className="product-description-wrapper">
                                    <div className="descriptions" dangerouslySetInnerHTML={{__html: item?.data?.shortDescription || ""}}>
                                      {/* HELPS YOU FIND YOUR ZEN – L-Theanine, a natural
                                    amino acid that helps reduce occasional stress,
                                    and lemon balm, a calming botanical, help get
                                    you in your zone. */}
                                      {/* {item?.data?.shortDescription || ""} */}
                                    </div>
                                    <div
                                      tabIndex={0}
                                      role="link"
                                      className="learn-more"
                                      onClick={() =>
                                        this.handleSeeMore("product", index)
                                      }
                                      onKeyPress={(e: any) => {
                                        if (
                                          e.key === "Enter" ||
                                          e.key === " "
                                        ) {
                                          this.handleSeeMore(
                                            "product",
                                            index,
                                            e
                                          );
                                        }
                                      }}
                                    >
                                      {this.props.t(
                                        "common.learn_more_product"
                                      )}
                                    </div>
                                  </div>

                                  <div className="add-to-cart-wrapper">
                                    <QuantityButton
                                      name={quantity}
                                      className="app-btn btn-quantity"
                                      handleDecrease={() =>
                                        this.decreaseQuantity()
                                      }
                                      handleIncrease={() =>
                                        this.increaseQuantity()
                                      }
                                    />
                                    {item?.data?.stock?.stockLevel > 0 ? (
                                      <Button
                                        name={this.props.t(
                                          "common.add_to_cart"
                                        )}
                                        className="app-btn btn-icon"
                                        onButtonClick={() =>
                                          this.handleAddtoCart(item?.data?.code)
                                        }
                                      />
                                    ) : (
                                      <Button
                                        name={this.props.t(
                                          "common.add_to_cart"
                                        )}
                                        className="app-btn out-of-stock"
                                        onButtonClick={
                                          () => this.handleOutOfStock()
                                          // this.handleAddtoCart(
                                          //   this.state.selectedProducts[0]?.data
                                          //     ?.code
                                          // )
                                        }
                                      />
                                    )}
                                  </div>

                                  {/* <div className="add-to-cart-wrapper">
                                  <QuantityButton
                                    name={"1"}
                                    className="app-btn btn-quantity"
                                    handleDecrease={() => {}}
                                    handleIncrease={() => {}}
                                    
                                  />
                                  <Button
                                    name={"Add to Cart"}
                                    className="app-btn btn-icon"
                                    onButtonClick={() => {}}
                                  />
                                </div> */}
                                </div>
                              </div>
                            </div>
                          )
                      )}

                    {this.state.selectedProducts &&
                      this.state.selectedProducts.length > 0 &&
                      this.state.selectedProducts.map(
                        (item: any) =>
                          item?.data?.name === "NOT FOUND" && (
                            // Product fallback cards Start
                            <div className="not-found-container">
                              <div className="not-found-card">
                                <div className="fallback-img-wrapper">
                                  <div className="product-fallback-img"></div>
                                </div>
                                <div className="not-found-product-details">
                                  <div className="heading">
                                    {this.props.t(
                                      "error.product_not_available"
                                    )}
                                  </div>
                                  <div className="details">
                                    {this.props.t(
                                      "error.product_fallback_details"
                                    )}
                                  </div>
                                </div>
                                <div className="sku-id">
                                  {this.props.t("error.sku_id")}{" "}
                                  {item?.data?.id || ""}
                                </div>
                              </div>
                            </div>
                          )
                      )}
                    {/* 
                    {this.state?.selectedProducts &&
                      this.state?.selectedProducts[0]?.data?.name ===
                        "NOT FOUND" && (
                        // Product fallback cards Start
                        <div className="not-found-container">
                          <div className="not-found-card">
                            <div className="fallback-img-wrapper">
                              <div className="product-fallback-img"></div>
                            </div>
                            <div className="not-found-product-details">
                              <div className="heading">
                                {this.props.t("error.product_not_available")}
                              </div>
                              <div className="details">
                                {this.props.t("error.product_fallback_details")}
                              </div>
                            </div>
                            <div className="sku-id">
                              {this.props.t("error.sku_id")}{" "}
                              {this.state?.selectedProducts[0]?.data?.id || ""}
                            </div>
                          </div>
                        </div>
                      )} */}
                    {/* {this.state?.selectedProducts &&
                      this.state?.selectedProducts[0]?.data &&
                      this?.state?.fallBackImageProduct &&
                      this.state?.selectedProducts[0]?.data?.name !==
                        "NOT FOUND" && (
                        <div className="product-wrapper bootstrap-wrapper">
                          <div className="inner-wrapper col-md-12 clearfix">
                            <div className="left-wrapper col-md-6 pull-left">
                             
                              <div className="slider-wrapper clearfix">
                                <div className="silder-images-wrapper">
                                  {this.state?.selectedProducts[0]?.data
                                    ?.images &&
                                  this.state?.selectedProducts[0]?.data?.images
                                    .length > 0 ? (
                                    <Slider
                                      {...this.getSettingsForThumbnails()}
                                    >
                                      {this.state?.selectedProducts[0]?.data?.images
                                        ?.filter(
                                          (element: any) =>
                                            element?.format === "product"
                                        )
                                        ?.map((item: any, itemIndex: any) => (
                                          <>
                                            <div
                                              className="slider-main-img"
                                              key={itemIndex}
                                            >
                                              <img
                                                tabIndex={-1}
                                                role="img"
                                                aria-labelledby="product-image"
                                                className={"slider-img"}
                                                src={
                                                  `${process.env.REACT_APP_IMGAE_BASE_URL}` +
                                                  item?.publicUrl
                                                    ? `${process.env.REACT_APP_IMGAE_BASE_URL}` +
                                                      item?.publicUrl
                                                    : this?.state
                                                        ?.fallBackImageProduct
                                                }
                                                alt=""
                                              />
                                            </div>
                                          </>
                                        ))}
                                    </Slider>
                                  ) : (
                                    this?.state?.fallBackImageProduct && (
                                      <div className="fallback-main-img">
                                        <img
                                          tabIndex={-1}
                                          role="img"
                                          aria-labelledby="product-image"
                                          className={"fallback-img"}
                                          src={
                                            this?.state?.fallBackImageProduct
                                          }
                                          alt=""
                                        />
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="right-wrapper col-md-6  pull-left">
                              <div className="product-detail-wrapper clearfix">
                                <div className="product-detail">
                                 
                                  <div
                                    className="product-name"
                                    id="product-image"
                                  >
                                    {this.state.selectedProducts[0]?.data
                                      ?.name || ""}
                                    
                                  </div>
                                  
                                  <div className="rating-star-wrapper">
                                    <StarRatings
                                     
                                      rating={
                                        this.state.selectedProducts[0]?.reviews
                                          ?.Results[0]?.ProductStatistics
                                          ?.ReviewStatistics
                                          ?.AverageOverallRating || 0
                                      }
                                      starRatedColor="#F1C400"
                                      numberOfStars={
                                        this.state.selectedProducts[0]?.reviews
                                          ?.Results[0]?.ProductStatistics
                                          ?.ReviewStatistics
                                          ?.OverallRatingRange || 5
                                      }
                                      name="rating"
                                      starDimension="15px"
                                      starSpacing="2px"
                                      
                                      svgIconPath={
                                        "M13.9695 4.58455L10.3498 4.0596C10.2798 4.0496 10.2248 4.0096 10.1948 3.94961L8.57495 0.664934C8.37497 0.25497 7.96 0 7.50004 0C7.04008 0 6.62511 0.254986 6.42512 0.664934L4.80526 3.94961C4.77527 4.0096 4.72027 4.0496 4.65028 4.0596L1.03059 4.58455C0.575624 4.65454 0.200665 4.96451 0.0606768 5.40447C-0.0843106 5.83944 0.0356789 6.31439 0.365642 6.63437L2.98541 9.18918C3.03541 9.23418 3.05541 9.29918 3.04541 9.36418L2.42546 12.9738C2.34547 13.4288 2.53045 13.8787 2.90043 14.1487C3.27541 14.4187 3.76035 14.4537 4.16531 14.2387L7.40999 12.5388C7.46498 12.5038 7.53498 12.5038 7.59497 12.5388L10.8347 14.2387C11.0097 14.3337 11.2047 14.3787 11.3946 14.3787C11.6396 14.3787 11.8896 14.3037 12.0996 14.1487C12.4695 13.8787 12.6545 13.4288 12.5745 12.9738L11.9546 9.36418C11.9446 9.29918 11.9646 9.23419 12.0146 9.18918L14.6344 6.63437C14.9643 6.31439 15.0843 5.83943 14.9393 5.40447C14.7993 4.96451 14.4244 4.65454 13.9694 4.58455H13.9695Z"
                                      }
                                      svgIconViewBox={"0 0 15 15"}
                                    />
                                    <span className="label">
                                      <span>
                                        {this.state.selectedProducts[0]?.reviews
                                          ?.Results[0]?.ProductStatistics
                                          ?.ReviewStatistics
                                          ?.AverageOverallRating
                                          ? this.state?.selectedProducts[0]?.reviews?.Results[0]?.ProductStatistics?.ReviewStatistics?.AverageOverallRating?.toFixed(
                                              1
                                            ) + " ("
                                          : "0   ("}
                                      </span>

                                      <span>
                                        {this.state.selectedProducts[0]?.reviews
                                          ?.Results[0]?.ProductStatistics
                                          ?.ReviewStatistics?.TotalReviewCount
                                          ? this.state.selectedProducts[0]
                                              ?.reviews?.Results[0]
                                              ?.ProductStatistics
                                              ?.ReviewStatistics
                                              ?.TotalReviewCount + ") "
                                          : 0 + ") "}
                                      </span>
                                      {this.props.t("common.reviews")}
                                     
                                    </span>
                                  </div>
                                </div>
                                <div className="product-price">
                                  {this.state.selectedProducts[0]?.data?.price
                                    ?.formattedValue || ""}
                                </div>
                              </div>
                              <div className="product-description-wrapper">
                                <div className="descriptions">
                                  
                                  {this.state.selectedProducts[0]?.data
                                    ?.summary || ""}
                                </div>
                                <div
                                  tabIndex={0}
                                  role="link"
                                  className="learn-more"
                                  onClick={(index: any) =>
                                    this.handleSeeMore("product", 0)
                                  }
                                  onKeyPress={(e: any) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                      this.handleSeeMore("product", 0, e);
                                    }
                                  }}
                                >
                                  {this.props.t("common.learn_more_product")}
                                </div>
                              </div>

                              <div className="add-to-cart-wrapper">
                                <QuantityButton
                                  name={quantity}
                                  className="app-btn btn-quantity"
                                  handleDecrease={() => this.decreaseQuantity()}
                                  handleIncrease={() => this.increaseQuantity()}
                                />
                                {this.state.selectedProducts[0]?.data?.stock
                                  ?.stockLevel > 0 ? (
                                  <Button
                                    name={this.props.t("common.add_to_cart")}
                                    className="app-btn btn-icon"
                                    onButtonClick={() =>
                                      this.handleAddtoCart(
                                        this.state.selectedProducts[0]?.data
                                          ?.code
                                      )
                                    }
                                  />
                                ) : (
                                  <Button
                                    name={this.props.t("common.add_to_cart")}
                                    className="app-btn out-of-stock"
                                    onButtonClick={
                                      () => this.handleOutOfStock()
                                     
                                    }
                                  />
                                )}
                              </div>

                              
                            </div>
                          </div>
                        </div>
                      )} */}
                  </div>
                  {!_.isEmpty(this.state?.combinedData?.products) &&
                    needStates &&
                    needStates.length > 0 &&
                    !this.state.isSurveyShort && (
                      <span
                        tabIndex={0}
                        role="link"
                        className="view-more-link"
                        onClick={() => this.handleViewMore("Products")}
                        onKeyPress={(e: any) => {
                          if (e.key === "Enter" || e.key === " ") {
                            this.handleViewMore("Products", e);
                          }
                        }}
                      >
                        {this.props.t("common.view_all_products")}
                      </span>
                    )}
                </div>
              </div>
            )}

            {/* Product Section Ends */}

            {/* Tips Section Start */}

            {this.state.loading3 === true ? (
              <Loader loaderClassName={"loader-wrapper"} />
            ) : (
              this.state.selectedTips &&
              this.state.selectedTips.length > 0 &&
              needStates &&
              needStates.length > 0 &&
              needStates?.filter((item: any) => item?.isSelected === true)?.[0]
                .name !== "everyday-health" &&
              !this.state.isSurveyShort && (
                <div className="tips-container">
                  <div className="inner-wrapper">
                    {tipsImage && tipsMBImage && (
                      <div
                        className="image-wrapper"
                        style={{
                          backgroundImage: visibleOnMobile
                            ? `url(${tipsMBImage})`
                            : `url(${tipsImage})`,
                        }}
                      >
                        <div className="overlay"></div>
                        <span className="heading">
                          {this.props.t("common.tips_to_try")}
                        </span>
                      </div>
                    )}

                    <TipsComponent
                      {...this.props}
                      colClassName="col-md-4"
                      tipsData={this.state?.selectedTips?.slice(0, 3)}
                      cardSettings={cardSettings}
                      handleSeeMore={(index: number, heading: string) =>
                        this.handleSeeMore("tips", index, heading)
                      }
                      handleSeeMoreOnKeyPress={(
                        index: number,
                        heading: string,
                        e: any
                      ) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleSeeMore("tips", index, heading, e);
                        }
                      }}
                    />

                    <span
                      tabIndex={0}
                      role="link"
                      className="view-more-link"
                      onClick={() => this.handleViewMore("Tips")}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          this.handleViewMore("Tips", e);
                        }
                      }}
                    >
                      {this.props.t("common.view_all_tips")}
                    </span>
                  </div>

                  {/* Tips Section Ends */}
                </div>
              )
            )}
          </div>
        </div>
        {/* Middle area Ends */}

        {/* Footer Section Start */}
        <Footer {...this.props} />
        {/* Footer Section Ends */}
      </div>
    );
  }
}

export default withOktaAuth(ResultsLandingPage);
